var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('ProjectService'),(_vm.getUserAccess.Access.VIEW.dashboard.metrics)?_c('b-row',[_c('InventoryHealth'),_c('UsersStats'),_c('UsersHealth')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }